module.exports = __webpack_public_path__ + "img/product_01.cded753.png";